import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { InputComponent } from '../../../shared/input/input.component';
import { ButtonGroupComponent } from '../../../shared/button-group/button-group.component';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-evacuation-form',
  standalone: true,
  imports: [
    InputComponent,
    ButtonGroupComponent,
    CommonModule,
    ReactiveFormsModule,
  ],
  templateUrl: './evacuation-form.component.html',
})
export class EvacuationFormComponent {
  @Input() formGroup!: FormGroup;
  @Input() possibleIdentification: string;

  yesNoOptions = [
    { label: $localize`:@@common.yes:Yes`, value: true },
    { label: $localize`:@@common.no:No`, value: false },
  ];

  get additionalHazardsLabel(): string {
    const sreLabels = [
      'OTHER_POSSIBLE_OSSEOUS_MATERIAL',
      'OTHER_POSSIBLE_MATERIAL_EVIDENCE',
      'OTHER_POSSIBLE_LIFE_SUPPORT_EQUIPMENT',
      'OTHER_POSSIBLE_AIRCRAFT_WRECKAGE',
    ];

    if (sreLabels.includes(this.possibleIdentification)) {
      return $localize`:@@evacuation.comments:Comments`;
    } else {
      return $localize`:@@heroReport.additionalHazards:Additional Hazards & Accessibility`;
    }
  }
}
